import { Box, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import { BusinessLineRoutes } from '../../utils/routingHelper';
import styles from './styles.module.scss';

type Variant = 'categorySetPage' | 'categoryPage';

interface PageHeroType {
  text: string;
  image: {
    altText: string;
    baseUrl: string;
    mediaPath: string;
  };
}

export const PAGE_HERO: Record<
  BusinessLineRoutes,
  Record<Variant, PageHeroType>
> = {
  men: {
    categorySetPage: {
      text: 'The easy way to discover styles that fit',
      image: {
        altText: "Men's clothing",
        baseUrl:
          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/w_1500/',
        mediaPath:
          '/v1721172154/landing-pages/pages/US/BRND-FY24-WEB-Rebrand%20Client%20Experience%20Audit-1207669956273077/Womens%20Brand%20Page/W_Brand_Hero.jpg',
      },
    },
    categoryPage: {
      text: 'The easy way to discover styles that fit',
      image: {
        altText: "Men's clothing",
        baseUrl:
          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/w_1500/',
        mediaPath:
          '/v1721172154/landing-pages/pages/US/BRND-FY24-WEB-Rebrand%20Client%20Experience%20Audit-1207669956273077/Womens%20Brand%20Page/W_Brand_Hero.jpg',
      },
    },
  },
  women: {
    categorySetPage: {
      text: 'Discovering styles you love just got easier',
      image: {
        altText: "Women's clothing",
        baseUrl:
          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/w_1500/',
        mediaPath:
          '/v1721172154/landing-pages/pages/US/BRND-FY24-WEB-Rebrand%20Client%20Experience%20Audit-1207669956273077/Womens%20Brand%20Page/W_Brand_Hero.jpg',
      },
    },
    categoryPage: {
      text: 'Discovering styles you love just got easier',
      image: {
        altText: "Women's clothing",
        baseUrl:
          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/w_1500/',
        mediaPath:
          '/v1721172154/landing-pages/pages/US/BRND-FY24-WEB-Rebrand%20Client%20Experience%20Audit-1207669956273077/Womens%20Brand%20Page/W_Brand_Hero.jpg',
      },
    },
  },
};

export interface PageHeroProps {
  businessLine: BusinessLineRoutes;
  variant: Variant;
}

/**
 * PageHero displays the Primary Hero copy and image at the top of the page
 * The content is statically managed for now and is customized to each businessLine
 */
const PageHero = ({ businessLine, variant }: PageHeroProps) => {
  const { text, image } = PAGE_HERO[businessLine][variant];

  return (
    <Box className={styles.pageHero} data-testid="page-hero">
      <Box className={styles.textContainer}>
        <ResponsiveSection width="xxlarge">
          <Text className={styles.text} setting="title-xlarge">
            {text}
          </Text>
        </ResponsiveSection>
      </Box>
      <Box
        className={styles.imageContainer}
        style={{ backgroundImage: `url('${image.baseUrl}${image.mediaPath}')` }}
        role="presentation"
      />
    </Box>
  );
};

export default PageHero;
